import React, { useState, useCallback, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import {
  recruiterHistoryPlanDetail,
  jobsApplicants,
} from "../../../services/SubRecruiterService";
import { downloadCSV } from "../../../helpers/dataTableHelper";

function HistoryPlanDetails() {
  const { id, rid } = useParams();

  const [Pdata, PsetData] = useState([]);
  const [Ploading, PsetLoading] = useState(false);
  const [PtotalRows, PsetTotalRows] = useState(0);
  const [PperPage, PsetPerPage] = useState(10);
  const [PcurrentPage, PsetCurrentPage] = useState(1);
  const [PreqParams, PsetReqParams] = useState({
    page: PcurrentPage,
    limit: PperPage,
    sort_by: "id",
    sort_direction: "DESC",
    bill_id: id,
    res_type: "favorites",
  });
  const [Pfetch, PsetFetch] = useState(true);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
    sort_by: "id",
    sort_direction: "DESC",
    bill_id: id,
    res_type: "unlocked",
  });
  const [fetch, setFetch] = useState(true);

  const [jdata, setJData] = useState([]);
  const [jloading, setJLoading] = useState(false);
  const [jtotalRows, setJTotalRows] = useState(0);
  const [jperPage, setJPerPage] = useState(10);
  const [jcurrentPage, setJCurrentPage] = useState(1);
  const [jreqParams, setJReqParams] = useState({
    page: currentPage,
    limit: perPage,
    sort_by: "id",
    sort_direction: "DESC",
    userId: rid,
    //res_type: "unlocked",
  });
  const [jfetch, setJFetch] = useState(true);

  const fetchUsers = useCallback(
    (params) => {
      setLoading(true);
      recruiterHistoryPlanDetail(params)
        .then((res) => {
          if (params?.res_type === "unlocked") {
            setData(res?.data?.unlocked);
            setTotalRows(res?.data?.totalRecords);
            setLoading(false);
            setFetch(false);
          } else if (params?.res_type === "favorites") {
            PsetData(res?.data?.favorites);
            PsetTotalRows(res?.data?.totalRecords);
            PsetLoading(false);
            PsetFetch(false);
          }
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          if (params?.type === "unlocked") {
            setLoading(false);
            setFetch(false);
          } else if (params?.type === "favorites") {
            PsetLoading(false);
            PsetFetch(false);
          }
        });
    },
    [setFetch, PsetFetch]
  );

  const fetchJobApplicants = useCallback(
    (params) => {
      setJLoading(true);
      jobsApplicants(params)
        .then((res) => {
          console.log(res);

          //  setJData(res?.data?.unlocked);
          //  setJTotalRows(res?.data?.totalRecords);
          //  setJLoading(false);
          //  setJFetch(false);
        })
        .catch((err) => {
          //swal("Error", err?.message, "error");
          //  setJFetch(false);
          //  setJLoading(false);
          //  if (params?.type === "unlocked") {
          //    setLoading(false);
          //    setFetch(false);
          //  } else if (params?.type === "favorites") {
          //    PsetLoading(false);
          //    PsetFetch(false);
          //  }
        });
    },
    [setJFetch]
  );

  useEffect(() => {
    if (fetch) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams]);

  useEffect(() => {
    if (Pfetch) {
      fetchUsers(PreqParams);
    }
  }, [Pfetch, PreqParams]);

  useEffect(() => {
    if (jfetch) {
      fetchJobApplicants(jreqParams);
    }
  }, [jfetch, jreqParams]);

  const columns = useMemo(
    () => [
      {
        name: "Candidate ID",
        selector: (row) => row.candidate_id,
        //sortable: true,
        sortField: "candidate_id",
      },
      {
        name: "Name",
        selector: (row) => row.legal_name,
        //sortable: true,
        sortField: "legal_name",
      },
      {
        name: "Preferred Name",
        selector: (row) => row.preferred_name,
        //sortable: true,
        sortField: "preferred_name",
      },
      {
        name: "Email",
        selector: (row) => row.email,
        wrap: true,
        //sortable: true,
        sortField: "email",
      },
      {
        name: "Created by",
        selector: (row) => row.created_by,
        //sortable: true,
        sortField: "created_by",
      },
      {
        name: "Date",
        selector: (row) => row.date,
        //sortable: true,
        sortField: "date",
      },
    ],
    []
  );

  const handlePageChange = useCallback(
    (page, type = "u") => {
      if (type === "u") {
        setCurrentPage(page);
        setReqParams({
          ...reqParams,
          page: page,
        });
        setFetch(true);
      } else if (type === "f") {
        PsetCurrentPage(page);
        PsetReqParams({
          ...PreqParams,
          page: page,
        });
        PsetFetch(true);
      }
    },
    [setReqParams, reqParams, setFetch, PsetReqParams, PreqParams, PsetFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page, type = "u") => {
      if (type === "u") {
        setPerPage(newPerPage);
        setReqParams({
          ...reqParams,
          limit: newPerPage,
        });
        setFetch(true);
      } else if (type === "f") {
        PsetPerPage(newPerPage);
        PsetReqParams({
          ...PreqParams,
          limit: newPerPage,
        });
        PsetFetch(true);
      }
    },
    [setReqParams, reqParams, setFetch, PsetReqParams, PreqParams, PsetFetch]
  );

  const handleSort = useCallback(
    (column, sortDirection, type = "u") => {
      if (column?.sortField !== undefined) {
        if (type === "u") {
          setReqParams({
            ...reqParams,
            sort_by: column.sortField,
            sort_direction: sortDirection,
          });
          setFetch(true);
        } else if (type === "f") {
          PsetReqParams({
            ...PreqParams,
            sort_by: column.sortField,
            sort_direction: sortDirection,
          });
          PsetFetch(true);
        }
      }
    },
    [reqParams, setReqParams, setFetch, PreqParams, PsetReqParams, PsetFetch]
  );

  return (
    <>
      <div className="row">
        <div className="col-xl-12 text-end mb-2">
          <button
            onClick={() => downloadCSV(data, "unlock-candidate-")}
            className="btn btn-warning btn-sm me-2"
          >
            <i className="fas fa-file-csv me-1"></i> Export
          </button>
          <Link to={`/${rid}/plan-history`} className="btn btn-sm btn-primary ">
            <i className="fa fa-arrow-left"></i> Back
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4>Unlock Profile</h4>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 200, 500]}
                  persistTableHead
                  //onSort={handleSort}
                  //sortServer
                  fixedHeader={true}
                  fixedHeaderScrollHeight={"500px"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-12 text-end mb-2">
          <button
            onClick={() => downloadCSV(Pdata, "favourite-candidate-")}
            className="btn btn-warning btn-sm me-2"
          >
            <i className="fas fa-file-csv me-1"></i> Export
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4>Favorite Profile</h4>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={Pdata}
                  progressPending={Ploading}
                  pagination
                  paginationServer
                  paginationTotalRows={PtotalRows}
                  paginationDefaultPage={PcurrentPage}
                  onChangeRowsPerPage={(a, b) => handlePerRowsChange(a, b, "f")}
                  onChangePage={(a) => handlePageChange(a, "f")}
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 200, 500]}
                  persistTableHead
                  //onSort={(a, b) => handleSort(a, b, "f")}
                  //sortServer
                  fixedHeader={true}
                  fixedHeaderScrollHeight={"500px"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row">
        <div className="col-xl-12 text-end mb-2">
          <button
            onClick={() => downloadCSV(Pdata, "favourite-candidate-")}
            className="btn btn-warning btn-sm me-2"
          >
            <i className="fas fa-file-csv me-1"></i> Export
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4>Favorite Profile</h4>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={setJData}
                  progressPending={jloading}
                  // pagination
                  // paginationServer
                  paginationTotalRows={jtotalRows}
                  paginationDefaultPage={jcurrentPage}
                  //onChangeRowsPerPage={(a, b) => handlePerRowsChange(a, b, "f")}
                  //onChangePage={(a) => handlePageChange(a, "f")}
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 200, 500]}
                  persistTableHead
                  //onSort={(a, b) => handleSort(a, b, "f")}
                  //sortServer
                  fixedHeader={true}
                  fixedHeaderScrollHeight={"500px"}
                />
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default HistoryPlanDetails;
